import styled from "styled-components"
import media from "styled-media-query"
import { Link } from "gatsby"

import { Whatsapp } from "styled-icons/boxicons-logos/Whatsapp"
import { LoginBox } from "styled-icons/remix-line/LoginBox"

export const NavbarWrapper = styled.header`
  align-items: center;
  background: linear-gradient(
      168deg,
      rgb(77, 47, 102) 0%,
      rgb(40, 73, 106) 75%,
      rgb(50, 91, 132) 100%
    )
    left bottom transparent no-repeat;
  /* box-shadow: 1px 2px 4px 10px #999; */
  color: ${props => props.theme.colors.primary};
  display: flex;
  flex-direction: row;
  font-family: ${props => props.theme.fonts.heading};
  font-weight: 400;
  height: 4em;
  justify-content: center;
  z-index: 0;
`

export const NavbarGroup = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: ${props => props.theme.padding};
  max-width: ${props => props.theme.maxWidth};
  width: 100%;
`

export const NavbarItem = styled.li`
  align-self: center;
  /* min-height: 100%; */
  display: none;
  padding: 0 0.5em;
  text-transform: uppercase;

  ${media.greaterThan("medium")`
    display: block;
  `}

  &:first-of-type {
    padding-left: 0;
  }

  &:last-of-type {
    padding-right: 0;
  }
`

export const NavbarItemCentered = styled.li`
  margin: 0 auto;
  text-align: center;
`

export const NavbarLink = styled(Link)`
  color: ${props => props.theme.colors.primary};
  opacity: 0.9;
  padding-bottom: 0.25em;
  text-decoration: none;
  transition: border-bottom 0.5s;

  &:hover {
    border-bottom: 2px solid ${props => props.theme.colors.highlight};
    opacity: 1;
  }
`

export const NavbarIconWhatsapp = styled(Whatsapp)`
  color: ${props => props.theme.colors.white};
  height: 1.25em;
  margin: 0 0.2em;
`

export const NavbarIconLogin = styled(LoginBox)`
  color: ${props => props.theme.colors.white};
  height: 1.25em;
  margin: -0.25em 0.25em 0 0;
`
